import { FieldComponent } from '@/types/FieldComponent';
import {
  Vue, Prop, Watch, Component,
} from 'vue-property-decorator';

@Component
export default class FieldComponentsFormData extends Vue {
  formData: Record<string, any> = {};

  @Prop()
  readonly fieldComponents!: FieldComponent[]

  bindFormDataValues(fieldComponents: FieldComponent[]) {
    this.formData = Object.fromEntries(fieldComponents.map(({ name, value }) => [name, value]));
  }

  @Watch('fieldComponents')
  onFieldComponentsChange(fieldComponents: FieldComponent[]) {
    this.bindFormDataValues(fieldComponents);
  }
}
